// extracted by mini-css-extract-plugin
module.exports = {"ProductFilter":"ProductFilter_ProductFilter__HtVHS","ProductFilter_wrapper":"ProductFilter_ProductFilter_wrapper__2KxWL"};